import { useNavigate } from 'react-router-dom';

import lang from '../../lib/language';

import Button from '../../shared_components/Button/Button';
import { ButtonTypesEnum } from '../../shared_components/Button/Button.types';
import { UI_ROUTES } from '../../util/routes';

import styles from './UpcomingEarnings.module.scss';

const UpcomingEarnings = () => {
  const navigate = useNavigate();
  const range = { startDate: undefined, endDate: undefined, key: 'selection' };

  return (
    <div className={styles.wrapper}>
      <div className={styles.textWrapper}>
        <div className={styles.title}>{lang.upcomingEarnings()}</div>
        <div className={styles.text}>{lang.upcomingEarningsText()}</div>
        <Button
          variant={ButtonTypesEnum.LinkSecondary}
          onClick={() => navigate(UI_ROUTES.discover + UI_ROUTES.earningsCalendar, {
            state: range,
          })}
          className={styles.viewMoreButton}
        >
          {lang.commonViewMore()}
        </Button>
      </div>
    </div>
  );
};

export default UpcomingEarnings;
